export default {
  metaDescription: 'PT Tokki Engineering and Fabrication(TEF)のキャリア機会をご覧ください。産業製作・エンジニアリング分野で成長を続けるチームにご参加ください。',
  pageTitle: '採用情報',
  noOpenings: '現在、募集中の求人はございません。今後の情報をお待ちください。',
  byAdmin: '投稿者：管理者',
  readMore: '続きを読む',
  modal: {
    department: '部署',
    location: '勤務地',
    level: 'レベル',
    jobSummary: '職務概要',
    responsibilities: '職務内容・責任',
    requirements: '応募資格',
    apply: '応募する',
  },
};
